import { Box, Chip } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const MembersComponent = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const BoxStyled = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  textOverflow: "ellipsis",
  height: 40,
  alignItems: "center",
}));

export const ChipStyled = styled(Chip)(() => ({
  backgroundColor: `#EDF5FB !important`,
  color: `#308cdb !important`,
  fontFamily: "Manrope",
  margin: "2px",
}));

type SelectBranchOptionProps = {
  isRemoving?: boolean;
};

export const SelectBranchOption = styled("span")(({ isRemoving }: SelectBranchOptionProps) => ({
  display: "flex",
  alignItems: "center",
  color: isRemoving ? colors.error600 : colors.brandBlue600,
}));

const styles = makeStyles(() => ({
  modalWrapper: {
    maxWidth: 442,
  },
  iconExtraAction: {
    cursor: "pointer",
  },
  select: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    "& fieldset": {
      "& legend": {
        fontSize: 0,
        margin: 0,
        "& span": {
          display: "none",
        },
      },
    },
  },
}));

export default styles;
